import { Routes } from '@angular/router';

const REPORTS_ROUTES: Routes = [
  {
    path: 'daily-analysis-2-0',
    loadChildren: () =>
      import('./bdc-analysis-2-0/bdc-analysis-2-0.module').then(m => m.BDCAnalysisModule),
  },
  {
    path: 'gm-kpi-trends',
    loadChildren: () =>
      import('./gm-kpi-trends/gm-kpi-trends.routes').then(m => m.GM_KPI_TRENDS_ROUTES),
  },
  {
    path: 'gm-snv',
    loadChildren: () =>
      import('./gm-snv/gm-snv.routes').then(m => m.GM_SNV_ROUTES),
  },
  {
    path: 'kia-kpi-details',
    loadChildren: () =>
      import('./kia-kpi-details/kia-kpi-details.routes'),
  },
  {
    path: 'rob-productivity-indices',
    loadChildren: () =>
      import('./rob-productivity-indices/rob-productivity-indices.routes'),
  },
  {
    path: 'monitoreo-ia',
    loadChildren: () =>
      import('./monitoreo-ia/monitoreo-ia.routes'),
  },
  {
    path: 'monitoring-ia',
    loadChildren: () =>
      import('./monitoring-ia/monitoring-ia.routes'),
  },
  {
    path: 'eventbridge-config',
    loadChildren: () =>
      import('./events-templates/events-templates.routes'),
  },
  {
    path: 'bdc-whatsapp-chat',
    loadChildren: () =>
      import('./bdc-whatsapp-chat/bdc-whatsapp-chat.routes'),
  },
];

export default REPORTS_ROUTES;
